import React, {useContext} from 'react';
import './HistoryOrderList.less';
import {OrderCard} from "compositions/order-card/OrderCard";
import {ListItem} from "elements/list-item/ListItem.tsx";
import {List} from "elements/list/List.tsx";
import {getSafeTranslation} from "helpers/localization.helper.ts";
import {TranslationsContext} from "contexts/translations-context";
import {Button} from "../../elements/button/Button";
import {getItemStringFromOrder} from "../../../helpers/order.helper";

export const HistoryOrderList = ({historyOrders, onOrderClick, onOrderAgainClick}) => {

	const translations = useContext(TranslationsContext);

	return <List>
		{
			historyOrders.map((historyOrder, index) => <ListItem key={historyOrder.orderId}
																													 onClick={() => onOrderClick(historyOrder.orderId)}>
				<OrderCard
					restaurantName={historyOrder.restaurantName}
					status={getSafeTranslation(historyOrder.statusString, translations)}
					date={historyOrder.placedAt.date}
					totalPrice={historyOrder.total}
					itemsString={getItemStringFromOrder(historyOrder)}
					actionControl={<Button
						isAutoWidth
						onClick={(event) => {
							event.stopPropagation();
							onOrderAgainClick(historyOrder)
						}}
					>
						{getSafeTranslation('HistoryOrderList.repeatOrderButtonCaption', translations)}
					</Button>}
				/>
			</ListItem>)
		}
	</List>
}
